import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的付款ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入付款名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
}




// WEBPACK FOOTER //
// ./src/views/payment-center/payment-center.rules.js